module.exports = __webpack_public_path__ + "static/awards-logo3-f7ffe56baae3f7fe252b1e6e58e8a85d.jpg";